import { render } from "./NetProfitChart.vue?vue&type=template&id=924c86e4&ts=true"
import script from "./NetProfitChart.vue?vue&type=script&lang=ts"
export * from "./NetProfitChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__